/* tslint:disable max-file-line-count */
import cachedGetResult from "../cachedGetResult";
import { Platform } from "../website";

export const errorInfo =
	"Opps, something is wrong. Please try again later or contact our customer service officer to assist you.";

interface Meta {
	catalog: string;
	lang: string;
	priceSymbol: string;
	priceGraph: string;
}
let platform: Platform;
let multiLanImgKey: string;

const meta: Meta = {
	catalog: "",
	lang: "",
	priceSymbol: "",
	priceGraph: "",
};

enum SiteCode {
	Ezbuy = 1,
	MCEzbuy = 2,
	LITB = 3,
}

// Server Side Render

export default class Constant {
	@cachedGetResult
	public static get siteCode(): number {
		return SiteCode.LITB;
	}

	public static set country(country: string) {
		try {
			if (country) {
				meta.catalog = country.toUpperCase();
			}
		} catch (e) {
			console.error(e);
		}
	}

	public static get country() {
		return meta.catalog;
	}

	public static set language(language: string) {
		try {
			if (language) {
				meta.lang = language.toLowerCase();
			}
		} catch (e) {
			console.error(e);
		}
	}

	public static get language() {
		return meta.lang;
	}

	public static set currency(currency: string) {
		try {
			if (currency) {
				meta.priceSymbol = currency.toUpperCase();
			}
		} catch (e) {
			console.error(e);
		}
	}

	public static get currency() {
		return meta.priceSymbol;
	}

	public static set priceGraph(graph: string) {
		try {
			meta.priceGraph = graph;
		} catch (e) {
			console.error(e);
		}
	}

	public static get priceGraph() {
		return meta.priceGraph;
	}

	public static set platform(newPlatform: Platform) {
		platform = newPlatform;
	}

	public static get platform() {
		return platform;
	}

	public static get metaData() {
		const { catalog, priceSymbol, lang } = meta;
		const platform = this.platform;
		return {
			catalog,
			priceSymbol,
			lang,
			client: platform,
		};
	}

	public static set multiLanImgKey(imgKey: string) {
		multiLanImgKey = imgKey;
	}

	public static get multiLanImgKey() {
		return multiLanImgKey;
	}
}
